// Completed By Rabbil Hasan
// 14-05-2014 5:43AM
import React, {Component,Fragment} from 'react';
class TermsDescriptionPlaceholder extends Component {
    render() {
        return (
            <Fragment>
                <div className="ph-item">
                    <div className="ph-col-12">
                        <div className="ph-row">
                            <div className="ph-col-12 small"/>
                            <div className="ph-col-12 small"/>
                            <div className="ph-col-12 small"/>
                            <div className="ph-col-12 small"/>
                            <div className="ph-col-12 small"/>
                            <div className="ph-col-12 small"/>
                            <div className="ph-col-12 small"/>
                        </div>
                    </div>
                </div>
                <br/>
                <div className="ph-item">
                    <div className="ph-col-12">
                        <div className="ph-row">
                            <div className="ph-col-12 small"/>
                            <div className="ph-col-12 small"/>
                            <div className="ph-col-12 small"/>
                            <div className="ph-col-12 small"/>
                            <div className="ph-col-12 small"/>
                            <div className="ph-col-12 small"/>
                            <div className="ph-col-12 small"/>
                        </div>
                    </div>
                </div>
                <br/>
                <div className="ph-item">
                    <div className="ph-col-12">
                        <div className="ph-row">
                            <div className="ph-col-12 small"/>
                            <div className="ph-col-12 small"/>
                            <div className="ph-col-12 small"/>
                            <div className="ph-col-12 small"/>
                            <div className="ph-col-12 small"/>
                            <div className="ph-col-12 small"/>
                            <div className="ph-col-12 small"/>
                        </div>
                    </div>
                </div>
                <br/>
                <div className="ph-item">
                    <div className="ph-col-12">
                        <div className="ph-row">
                            <div className="ph-col-12 small"/>
                            <div className="ph-col-12 small"/>
                            <div className="ph-col-12 small"/>
                            <div className="ph-col-12 small"/>
                            <div className="ph-col-12 small"/>
                            <div className="ph-col-12 small"/>
                            <div className="ph-col-12 small"/>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default TermsDescriptionPlaceholder;